export default __webpack_public_path__ + "static/media/closet5-after1-480w.99fe27b7.png";